module.exports = __webpack_public_path__ + "media/images/checkout/challenger/lock_person-8846fe47368b9acf5cc1854f7acd6f09.svg";